<!-- Content -->
<div class="content container-fluid">
  <!-- Page Header -->
  <header class="page-header">
    <nav attr.aria-label="{{ 'wcag.breadcrumb' | translate }}">
      <ol class="breadcrumb">
        <breadcrumb></breadcrumb>
      </ol>
    </nav>

    <h1 class="page-header-title">
      {{ (operationInternalEvent$ | async)?.type }}
    </h1>
  </header>
  <!-- End Page Header -->

  <!-- Nav -->

  <!-- <nav attr.aria-label={{ 'wcag.internalOperationMenu' | translate}}><ul
    class="nav nav-tabs align-items-center mb-3"
    *ngIf="operationInternalEvent$ | async as operationInternalEvent"
  >
    <li class="nav-item">
      <a
        [routerLink]="[
          '/operation-internal-events/',
          operationInternalEvent.id
        ]"
        routerLinkActive="active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="nav-link"
      >
        <i role="img" class="fa fa-cube" aria-hidden="true"></i>
        {{ 'general.general' | translate }}
      </a>
    </li>
  </ul></nav> -->

  <!-- End Nav -->

  <div class="w-100">
    <router-outlet></router-outlet>
  </div>
</div>
